import { render } from "./beautyVideoList.vue?vue&type=template&id=2d738942&scoped=true"
import script from "./beautyVideoList.vue?vue&type=script&lang=js"
export * from "./beautyVideoList.vue?vue&type=script&lang=js"

import "./beautyVideoList.vue?vue&type=style&index=0&id=2d738942&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d738942"]])

export default __exports__